<template>
  <div>
    <h3>Tests</h3>
  
    <h4>wifi</h4>    
    
    <!--
      1,0 och 1,1 = bw20
      annars bw40
    -->
    
    <div><a @click="wifiTest('g', 1, 108, 'bw20M')" href="#">11g, 54 MBps Ch 1</a></div>
    <div><a @click="wifiTest('g', 7, 108, 'bw20M')" href="#">11g, 54 MBps Ch 7</a></div>
    <div><a @click="wifiTest('g', 13, 108, 'bw20M')" href="#">11g, 54 MBps Ch 13</a></div>
    
    <div><a @click="wifiTest('g', 1, 12, 'bw20M')" href="#">11g, 6 MBps Ch 1</a></div>
    <div><a @click="wifiTest('g', 7, 12, 'bw20M')" href="#">11g, 6 MBps Ch 7</a></div>
    <div><a @click="wifiTest('g', 13, 12, 'bw20M')" href="#">11g, 6 MBps Ch 13</a></div>

    <div><a @click="wifiTest('b', 1, 22, 'bw20M')" href="#">11b, 11 MBps Ch 1</a></div>
    <div><a @click="wifiTest('b', 7, 22, 'bw20M')" href="#">11b, 11 MBps Ch 7</a></div>
    <div><a @click="wifiTest('b', 13, 22, 'bw20M')" href="#">11b, 11 MBps Ch 13</a></div>

    <div><a @click="wifiTest('b', 1, 2, 'bw20M')" href="#">11b, 1 MBps Ch 1</a></div>
    <div><a @click="wifiTest('b', 7, 2, 'bw20M')" href="#">11b, 1 MBps Ch 7</a></div>
    <div><a @click="wifiTest('b', 13, 2, 'bw20M')" href="#">11b, 1 MBps Ch 13</a></div>

    <div><a @click="wifiTest('n', 1, 135, 'bw20M')" href="#">11n, 20 MBps Ch 1 (MCS7)</a></div>
    <div><a @click="wifiTest('n', 7, 135, 'bw20M')" href="#">11n, 20 MBps Ch 7 (MCS7)</a></div>
    <div><a @click="wifiTest('n', 13, 135, 'bw20M')" href="#">11n, 20 MBps Ch 13 (MCS7)</a></div>

    <div><a @click="wifiTest('n', 3, 135, 'bw40M')" href="#">11n, 40 MBps Ch 3 (MCS7)</a></div>
    <div><a @click="wifiTest('n', 7, 135, 'bw40M')" href="#">11n, 40 MBps Ch 7 (MCS7)</a></div>
    <div><a @click="wifiTest('n', 11, 135, 'bw40M')" href="#">11n, 40 MBps Ch 11 (MCS7)</a></div>
    
    <button @click="wifiStop" style="margin-top:20px;">stop wifi test</button>
    
    <table>
      <tbody>
        <tr><td></td></tr>
      </tbody>
    </table>
    
    
    
    
    <!--
    <table>
      <thead>
        <tr>
          <th>standard</th>
          <th>rateMbs</th>
          <th>channel</th>
          <th colspan="3">bandwidth</th>
        </tr>
      </thead>

      <tbody>
        <tr class="nohover">
          <td>
            <select v-model="wifi.standard">
              <option>b</option>
              <option>g</option>
              <option>n</option>
            </select>
          </td>
          
          <td><input type="number" v-model.number="wifi.rateMbs" placeholder="rateMbs"></td>
          <td><input type="number" v-model.number="wifi.channel" placeholder="channel"></td>
          <td>
            <select v-model="wifi.bandwidth">
              <option>bw40M</option>
              <option>bw20M</option>
            </select>
          </td>
          <td><button @click="runWifi">run</button></td>
          <td></td>
        </tr>
      </tbody>
    </table>
    -->
    
    <hr>
    
    <h4>other</h4>
    
    <button @click="url('nxtHWreset')">NXT HW reset</button>
    <hr>
    <button @click="url('nxtOOKStart')">Start continuous OOK PRBS TX pattern</button>
    <hr>
    <button @click="url('nxtLoraStart')">Start continuous LoRa PRBS TX pattern</button>
    <hr>
    <button @click="url('nxtUnmodulatedStart')">Start continuous TX</button>
    <hr>
    <button @click="url('nxtUnmodulatedStop')">Stop continuous TX</button>

    <hr>
    <h4>Z-Wave</h4>
    
    <select v-model.number="zwave_testnr">
      <option value="1">TX zwave carrier ch 1</option>
      <option value="2">TX zwave modulated ch 1</option>
      <option value="3">TX zwave carrier ch 2</option>
      <option value="4">TX zwave modulated ch 2</option>
      <option value="5">RX zwave ch 1</option>
      <option value="6">RX zwave ch 2</option>
    </select>
    
    <button style="margin-top:1em;" @click="startZwave">start z-wave test</button>
    <button style="margin-top:1em;" @click="stopZwave">abort z-wave test</button>

    
    <hr>
    <button @click="url('zwaveRebootInNormalMode')">Reboot Zwave in normal mode</button>
    <hr>
    <button @click="url('zwaveRebootInTestMode')">Reboot zwave in test mode</button>
    
    <h4>mac</h4>
    
    <input type="text" v-model="mac" placeholder="MAC"> <button @click="setMac">set</button>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { HTTP2 } from '../http2.js'

  export default {
    name: 'installningar_tester',
    components: {},
    data () {
      return {
        wifi: {
          standard: 'b',
          rateMbs: 56,
          channel: 5,
          bandwidth: 'bw40M'
        },
        zwave_testnr: 0,
        mac: ''
      }
    },
    created () {

    },
    methods: {    
      wifiTest (standard, channel, rateMbs, bandwidth) {
        //let bw = 'bw40M'
        //if (bandwidth === '1,0' || bandwidth === '1,1') {
        //  bw = 'bw20M'
        //}
        const bw = bandwidth
      
        HTTP2.post('certtest/wifiStartTx?wifiStandard=' + standard + '&rateMbs=' + rateMbs + '&channel=' + channel + '&bandwidth=' + bw)
        .then(d => d.data)
        .then(json => {
          alert('running')
        })
      },

      runWifi () {
        HTTP2.post('certtest/wifiStartTx?wifiStandard=' + this.wifi.standard + '&rateMbs=' + this.wifi.rateMbs + '&channel=' + this.wifi.channel + '&bandwidth=' + this.wifi.bandwidth)
        .then(d => d.data)
        .then(json => {
          alert('running')
        })
      },
      
      wifiStop () {
        HTTP2.post('certtest/wifiStopTx')
        alert('stopped')
      },
      
      url (path) {
        HTTP2.post('certtest/' + path)
        .then(res => res.data)
        .then(json => {
          alert(JSON.stringify(json))
        })
      },
      
      startZwave () {
        HTTP2.post('certtest/zwaveStartTest?testnr=' + this.zwave_testnr)
        .then(res => res.data)
        .then(json => {
          alert(JSON.stringify(json))
        })
      },
      
      stopZwave () {
        HTTP2.post('certtest/zwaveCancel')
        .then(res => res.data)
        .then(json => {
          alert(JSON.stringify(json))
        })
      },
      
      setMac () {
        HTTP2.post('certtest/macAddressSet?address=' + this.mac)
        .then(res => res.data)
        .then(json => alert(JSON.stringify(json)))
      }
    },
    computed: {

    },
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_tester.vue